export class Activity {
  activityId: string | undefined;
  activityType: string | undefined;
  name: string | undefined;
}
